import React from 'react';
import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI } from '../Interface';

const PartnerSettingFields = ({ viewField }) => {
  const { values, errors } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          name="defCompanyShippingAddr"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Alap. szállítási cím megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defCompanyShippingAddr} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defCompanyShippingAddr && values.defCompanyShippingAddr !== '' }}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          name="defCompanyBillingAddr"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Alap. számlázási cím megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defCompanyBillingAddr} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defCompanyBillingAddr && values.defCompanyBillingAddr !== '' }}
        />
      </div>
    </div>
  );
};

export default PartnerSettingFields;
